import { Grid, IconButton, InputAdornment, MenuItem, } from '@mui/material';
import { branchId, companyId, countryId, formatCurrency } from '../../../../services/ApiService';
import ModalAccount from '../ModalEPL/ModalAccount'
import DollarInput from '../../../../components/Masks/DollarInput';
import RupiahInput from '../../../../components/Masks/RupiahInput';
import React, { useState } from 'react';
import CustomizeButtonComponent from '../../../../components/Buttons/CustomizeButtonComponent';
import { Icon, Input, PopUp, Selection, showToast } from '../../../../components/ui';
import { convertToNumeric, maxAmountIDR, maxAmountUSD } from '../../../../utils/masks.jsx';
import { defaultDate } from '../../../../utils/date.jsx';
import ModalConfirmationNominal from '../../../../components/Modals/ModalConfirmationNominal.jsx';

const ModalDetail = (props) => {
    const [isModalConfirmation, setIsModalConfirmation] = useState(false);
    const [currency, setCurrency] = useState('IDR');

    document.onkeyup = escapeFunction;
    function escapeFunction(e) {
        var keyCode = e.keyCode;
        var valid = (keyCode === 27 || e.key === 'Escape');

        if (valid) {
            if (e.keyCode === 27 || e.key === 'Escape') {
                props.handleModalDetail();
                props.clearForm();
            }
        }
    }

    const BankTypeData = [
        { id: 1, code: 0, name: 'USD' },
        { id: 2, code: 1, name: 'IDR' },
    ];

    const CostToCostData = [
        { id: 1, code: false, name: 'No' },
        { id: 2, code: true, name: 'Yes' },
    ];

    const signData = [
        { id: 1, code: true, name: '+' },
        { id: 2, code: false, name: '-' }
    ];

    const saveData = () => {
        let amount_IDR = 0;
        let amount_USD = 0;

        let errMsg = undefined;

        if (props.contactId === 0) {
            errMsg = 'Please Select The Contact!';
        }
        else if (props.accountId === 0) {
            errMsg = 'Please Select The Account!';
        }
        else if (parseFloat(convertToNumeric(props.Amount)) <= 0) {
            errMsg = 'Please Fill The Amount!';
        }
        else if (parseInt(props.QtyUnit) <= 0) {
            errMsg = 'Please Fill The Quantity Unit!';
        }
        else if (parseFloat(convertToNumeric(props.PerUnitCost)) <= 0) {
            errMsg = 'Please Fill The Per Unit Cost!';
        }

        if (errMsg === undefined) {
            if (props.Currency === 0) {
                amount_USD = parseFloat(convertToNumeric(props.Amount));
            }
            else {
                amount_IDR = parseFloat(convertToNumeric(props.Amount));
            }

            let CTI = props.contactType
            let II = props.isIncome

            const customerId = props.contactId

            let Sequence = 1
            if (props.isAdd) {
                if (props.dataDetail.length > 0) {
                    let data = props.dataDetail.reduce((prev, current) => (prev && prev.sequence > current.sequence) ? prev : current);
                    Sequence = data.sequence + 1;
                }
            }
            else {
                Sequence = props.sequence
            }

            const payload2 = {
                "rowStatus": "ACT",
                "id": 0,
                "eplId": props.eplId,
                "countryId": countryId,
                "companyId": companyId,
                "branchId": branchId,
                "sequence": Sequence,
                "isIncome": II,
                "customerId": customerId,
                "customerTypeId": CTI,
                "customerName": props.contactName,
                "accountId": props.accountId,
                "accountCode": props.accountCode,
                "accountName": props.accountName,
                "coaCode": props.COACode,
                "coaName": props.COAName,
                "description": props.Desc,
                "codingQuantity": false,
                "type": '0',
                "quantity": props.QtyUnit ? parseFloat(props.QtyUnit) : parseFloat(0),
                "perQty": convertToNumeric(props.PerUnitCost),
                "amountCrr": parseInt(props.Currency),
                "amountUSD": parseFloat(amount_USD),
                "amountIDR": parseFloat(amount_IDR),
                "sign": props.sign,
                "dataFrom": false,
                "memoNo": 0,
                "statusMemo": false,
                "createdMemoOn": defaultDate,
                "paidPR": false,
                "isSplitIncCost": props.SplitAccount,
                "isContainer": props.isContainer,
                "containerSize": props.containerSize,
                "formatContainer": props.containerFormat,
                "containerTypeId": props.containerTypeId,
                "containerTypeCode": props.containerTypeCode,
                "containerTypeName": props.containerTypeName,
                "idLama": 0,
                "isCostToCost": props.CostToCost,
                "truck_detail_id": 0,
                "isCostTrucking": props.CostTrucking,
                "isAdditional": false,
                "isIgnoreItem": false,
                "kendaraanId": 0,
                "kendaraanNopol": "",
                "employeeId": 0,
                "employeeName": "",
                "mrgId": 0,
                "refId": 0,
                "deliveryDate": defaultDate,
                "originalUsd": convertToNumeric(props.OriginalUSD),
                "originalRate": convertToNumeric(props.OriginalRate),
                "bookingDetailId": 0,
                "user": "",
                "estimateProfitLossDetailStorages": []
            }

            if (props.isAdd) {
                if (II === true && CTI === 2) {
                    props.setIncShipperList([...props.IncShipperList, payload2])
                } else if (II === true && CTI === 1) {
                    props.setIncAgentList([...props.IncAgentList, payload2])
                } else if (II === true && CTI === 3) {
                    props.setIncConsigneeList([...props.IncConsigneeList, payload2])
                } else if (II === false && CTI === 4) {
                    props.setCostSSLineList([...props.CostSSLineList, payload2])
                } else if (II === false && CTI === 5) {
                    props.setCostIATAList([...props.CostIATAList, payload2])
                } else if (II === false && CTI === 6) {
                    props.setCostEMKLList([...props.CostEMKLList, payload2])
                } else if (II === false && CTI === 7) {
                    props.setCostDepoList([...props.CostDepoList, payload2])
                } else if (II === false && (CTI === 8 || CTI === 2)) {
                    payload2.customerTypeId = 8;
                    props.setCostDiscountShipperList([...props.CostDiscountShipperList, payload2])
                } else if (II === false && (CTI === 9 || CTI === 3)) {
                    payload2.customerTypeId = 9;
                    props.setCostDiscountConsigneeList([...props.CostDiscountConsigneeList, payload2])
                } else if (II === false && CTI === 1) {
                    props.setCostAgentList([...props.CostAgentList, payload2])
                } else {
                    props.setCostTruckingList([...props.CostTruckingList, payload2])
                }

                props.setDataDetail([...props.dataDetail, payload2])
                props.countSum([...props.dataDetail, payload2])
                props.countTotalData([...props.dataDetail, payload2])
                props.clearForm();
            }
            else {
                const newArr = props.dataDetail.slice()
                if (II === false && (CTI === 8 || CTI === 2)) {
                    payload2.customerTypeId = 8;
                } else if (II === false && (CTI === 9 || CTI === 3)) {
                    payload2.customerTypeId = 9;
                }
                newArr.forEach(el => {
                    if (el.sequence === Sequence) {
                        el.eplId = payload2.accountId
                        el.isIncome = payload2.isIncome
                        el.customerId = payload2.customerId
                        el.customerName = payload2.customerName
                        el.customerTypeId = payload2.customerTypeId
                        el.accountId = payload2.accountId
                        el.accountCode = payload2.accountCode
                        el.accountName = payload2.accountName
                        el.coaCode = payload2.coaCode
                        el.coaName = payload2.coaName
                        el.description = payload2.description
                        el.formatContainer = payload2.formatContainer
                        el.containerTypeId = payload2.containerTypeId
                        el.containerTypeCode = payload2.containerTypeCode
                        el.containerTypeName = payload2.containerTypeName
                        el.quantity = payload2.quantity
                        el.perQty = payload2.perQty
                        el.amountUSD = payload2.amountUSD
                        el.amountIDR = payload2.amountIDR
                        el.isSplitIncCost = payload2.isSplitIncCost
                        el.isCostToCost = payload2.isCostToCost
                        el.isCostTrucking = payload2.isCostTrucking
                        el.originalUsd = payload2.originalUsd
                        el.originalRate = payload2.originalRate
                        el.amountCrr = payload2.amountCrr
                        el.sign = payload2.sign
                    }
                })
                props.setDataDetail(newArr)
                props.countSum(newArr)
                props.countTotalData(newArr)
                let data2 = newArr.filter(el => el.customerTypeId === CTI && el.isIncome === II)
                if (II === true && CTI === 2) {
                    props.setIncShipperList(data2)
                } else if (II === true && CTI === 3) {
                    props.setIncConsigneeList(data2)
                } else if (II === true && CTI === 1) {
                    props.setIncAgentList(data2)
                } else if (II === false && CTI === 4) {
                    props.setCostSSLineList(data2)
                } else if (II === false && CTI === 5) {
                    props.setCostIATAList(data2)
                } else if (II === false && CTI === 6) {
                    props.setCostEMKLList(data2)
                } else if (II === false && CTI === 7) {
                    props.setCostDepoList(data2)
                } else if (II === false && (CTI === 8 || CTI === 2)) {
                    data2.customerTypeId = 8;
                    props.setCostDiscountShipperList(data2)
                } else if (II === false && (CTI === 9 || CTI === 3)) {
                    data2.customerTypeId = 9;
                    props.setCostDiscountConsigneeList(data2)
                } else if (II === false && CTI === 1) {
                    props.setCostAgentList(data2)
                } else {
                    props.setCostTruckingList(data2)
                }

                props.clearForm();
            }

            if (props.isDummy === true) {
                showToast({ type: 'warning', message: 'There Still Dummy Container On Shipment Order! Please Update The Container!' });
            }

            props.handleModalDetail();
        }
        else {
            showToast({ type: 'error', message: errMsg });
        }
    }

    const handleClickConfirmation = () => {
        if (isModalConfirmation === false) {
            setIsModalConfirmation(true);
        }
        else {
            setIsModalConfirmation(false);
        }
    }

    const handleCheckNominal = () => {
        if (!props.isAdd) {
            let Sequence = props.sequence;
            let data = props.dataDetail.filter((el) => el.sequence === Sequence)
            let dataAmount = data[0].amountCrr === 0 ? data[0].amountUSD : data[0].amountIDR;
            if (convertToNumeric(dataAmount) === convertToNumeric(props.Amount)) {
                saveData();
            }
            else {
                handleValidationCurrency();
            }
        }
        else {
            handleValidationCurrency();
        }
    }

    const handleValidationCurrency = () => {
        if (props.Currency === 0) {
            setCurrency('USD');
            if (parseFloat(convertToNumeric(props.Amount)) >= maxAmountUSD) {
                handleClickConfirmation();
            }
            else {
                saveData();
            }
        }
        else {
            setCurrency('IDR');
            if (parseFloat(convertToNumeric(props.Amount)) >= maxAmountIDR) {
                handleClickConfirmation();
            }
            else {
                saveData();
            }
        }
    }

    const handleConfirmation = () => {
        saveData();
        handleClickConfirmation();
    }

    function handleOriginalUSD(value) {
        if (value !== null && value !== undefined && value !== '') {
            props.setOriginalUSD(value);

            props.setPerUnitCost(parseFloat((convertToNumeric(value) * convertToNumeric(props.OriginalRate)).toFixed(5)));
            props.setAmount(parseFloat((parseFloat((convertToNumeric(value) * convertToNumeric(props.OriginalRate)).toFixed(5)) * convertToNumeric(props.QtyUnit)).toFixed(5)));
        }
    }

    function handleOriginalRate(value) {
        if (value !== null && value !== undefined && value !== '') {
            props.setOriginalRate(value);

            props.setPerUnitCost(parseFloat((convertToNumeric(value) * convertToNumeric(props.OriginalUSD)).toFixed(5)));
            props.setAmount(parseFloat((parseFloat((convertToNumeric(value) * convertToNumeric(props.OriginalUSD)).toFixed(5)) * convertToNumeric(props.QtyUnit)).toFixed(5)));
        }
    }

    function handleQuantityUnit(value) {
        if (value !== null && value !== undefined && value !== '') {
            props.setQtyUnit(value);
            props.setAmount(parseFloat((convertToNumeric(value) * convertToNumeric(props.PerUnitCost)).toFixed(5)));
        }
    }

    function handlePerUnitCost(value) {
        if (value !== null && value !== undefined && value !== '') {
            props.setPerUnitCost(value);
            props.setAmount(parseFloat((convertToNumeric(value) * convertToNumeric(props.QtyUnit)).toFixed(5)));
        }
    }

    function handleContainerSize(value) {
        props.setContainerFormat(value);
        if (props.isContainer) {
            props.containerSizeData.forEach(element => {
                if (element.formatContainer === value) {
                    props.setContainerSize(element.containerSize);
                    props.setContainerTypeId(element.containerTypeId);
                    props.setContainerTypeCode(element.containerTypeCode);
                    props.setContainerTypeName(element.containerTypeName);
                    handleQuantityUnit(element.totalContainer);
                }
            });
        }
        else {
            handleQuantityUnit(0);
            props.setContainerSize('All');
            props.setContainerTypeId(0);
            props.setContainerTypeCode('');
            props.setContainerTypeName('');
            props.setIsOthers(false);
        }
    }

    const mainContainer = (
        <div style={{ padding: '12px 0px 0px 8px' }}>
            <Input
                label={
                    props.TabType === 'Inc Agent' || props.TabType === 'Inc Shipper' || props.TabType === 'Inc Consignee' ?
                        'Invoice To'
                        :
                        'Cost To'
                }
                value={props.contact}
                disabled
                formControlProps={{
                    sx: {
                        width: '100%',
                    }
                }}
                fullWidth
            />

            <div style={{ marginTop: '16px' }}>
                <Grid
                    container
                    spacing={'32px'}
                >
                    <Grid
                        item
                        xl={4}
                        lg={4}
                        sm={4}
                        xs={12}
                    >
                        <Input
                            label={props.contact + ' Id'}
                            value={props.contactId}
                            disabled
                            formControlProps={{
                                sx: {
                                    width: '100%',
                                }
                            }}
                            inputBaseProps={{
                                readOnly: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => props.handleModalContact('delete')}
                                            hidden={props.contactId && !(props.isViewOnly || props.isReadOnly) ? false : true}
                                        >
                                            <Icon
                                                iconName={'close'}
                                                svgIconProps={{
                                                    fontSize: 'small',
                                                    htmlColor: '#0087C2',
                                                    sx: {
                                                        height: '12px',
                                                        width: '12px'
                                                    }
                                                }}
                                            />
                                        </IconButton>

                                        <IconButton
                                            onClick={() => { props.handleModalContact('search') }}
                                            hidden={props.isViewOnly || props.isReadOnly}
                                        >
                                            <Icon
                                                iconName={'search'}
                                                svgIconProps={{
                                                    fontSize: 'small',
                                                    htmlColor: '#0087C2',
                                                    sx: {
                                                        height: '12px',
                                                        width: '12px'
                                                    }
                                                }}
                                            />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>

                    <Grid
                        item
                        xl={8}
                        lg={8}
                        sm={8}
                        xs={12}
                    >
                        <Input
                            label={props.contact + ' Name'}
                            variant="standard"
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            value={props.contactName}
                            type='text'
                            disabled
                            formControlProps={{
                                sx: {
                                    width: '100%',
                                }
                            }}
                            inputBaseProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                </Grid>
            </div>

            <div style={{ marginTop: '16px' }}>
                <Grid
                    container
                    spacing={'32px'}
                >
                    <Grid
                        item
                        xl={4}
                        lg={4}
                        sm={4}
                        xs={12}
                    >
                        <Input
                            label={'Account Code'}
                            value={props.accountCode}
                            disabled
                            fullWidth
                            formControlProps={{
                                sx: {
                                    width: '100%',
                                }
                            }}
                            inputBaseProps={{
                                readOnly: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => props.handleModalAccount('delete')}
                                            hidden={props.accountCode && (!(props.isViewOnly || props.isReadOnly) && !props.isAdditional) ? false : true}
                                        >
                                            <Icon
                                                iconName={'close'}
                                                svgIconProps={{
                                                    fontSize: 'small',
                                                    htmlColor: '#0087C2',
                                                    sx: {
                                                        height: '12px',
                                                        width: '12px'
                                                    }
                                                }}
                                            />
                                        </IconButton>

                                        <IconButton
                                            onClick={() => props.handleModalAccount('search')}
                                            hidden={!(props.isViewOnly || props.isReadOnly) && !props.isAdditional ? false : true}
                                        >
                                            <Icon
                                                iconName={'search'}
                                                svgIconProps={{
                                                    fontSize: 'small',
                                                    htmlColor: '#0087C2',
                                                    sx: {
                                                        height: '12px',
                                                        width: '12px'
                                                    }
                                                }}
                                            />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>

                    <Grid
                        item
                        xl={4}
                        lg={4}
                        sm={4}
                        xs={12}
                    >
                        <Selection
                            id='0'
                            label={'Container Size'}
                            value={props.containerFormat}
                            fullWidth={true}
                            placeholder={'Select Container Size'}
                            onChange={(e) => handleContainerSize(e.target.value)}
                            disabled={!props.isContainer || props.isViewOnly || props.isReadOnly}
                        >
                            <MenuItem sx={{ fontSize: '12px' }} key={0} value={'All'}>All</MenuItem>
                            {
                                props.isContainer ?
                                    props.containerSizeData.map((data, index) => (
                                        <MenuItem sx={{ fontSize: '12px' }} key={index} value={data.formatContainer}>{data.formatContainer}</MenuItem>
                                    ))
                                    :
                                    <span></span>
                            }
                        </Selection>
                    </Grid>

                    <Grid
                        item
                        xl={4}
                        lg={4}
                        sm={4}
                        xs={12}
                    >
                        <Selection
                            id='0'
                            label={'Split Account'}
                            fullWidth={true}
                            placeholder={'Select Split Account'}
                            value={props.SplitAccount}
                            onChange={(e) => props.setSplitAccount(e.target.value)}
                            hidden={props.TabType === 'Inc Agent' || props.TabType === 'Cost Agent' ? true : false}
                            disabled={props.isViewOnly || props.isReadOnly}
                        >
                            {
                                CostToCostData.map((data, index) => (
                                    <MenuItem sx={{ fontSize: '12px' }} key={index} value={data.code}>{data.name}</MenuItem>
                                ))
                            }
                        </Selection>
                    </Grid>
                </Grid>
            </div>

            <div style={{ marginTop: '16px' }}>
                <Input
                    label={'Account Name'}
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={props.accountName}
                    type='text'
                    disabled
                    formControlProps={{
                        sx: {
                            width: '100%',
                        }
                    }}
                    inputBaseProps={{
                        readOnly: true
                    }}
                />
            </div>

            <Input
                label={'Description'}
                value={props.Desc}
                onChange={(e) => props.setDesc(e.target.value)}
                multiline
                fullWidth
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
                inputBaseProps={{
                    rows: 4,
                    sx: {
                        padding: '8px',
                    },
                }}
                disabled={props.isViewOnly || props.isAdditional || props.isReadOnly}
            />

            <div className='mt-3'>
                <Grid
                    container
                    spacing={'32px'}
                >
                    <Grid
                        item
                        xl={3}
                        lg={3}
                        sm={3}
                        xs={12}
                    >
                        <Selection
                            id='0'
                            label={'Currency'}
                            fullWidth={true}
                            placeholder={'Select Currency'}
                            value={props.Currency}
                            onChange={(e) => props.setCurrency(e.target.value)}
                            disabled={props.isViewOnly || props.isAdditional || props.isReadOnly}
                        >
                            {
                                BankTypeData.map((data, index) => (
                                    <MenuItem sx={{ fontSize: '12px' }} key={index} value={data.code}>{data.name}</MenuItem>
                                ))
                            }
                        </Selection>

                        <Input
                            label={'Quantity Unit'}
                            textAlign='right'
                            fullWidth
                            value={props.QtyUnit}
                            disabled={props.isViewOnly || props.isReadOnly}
                            onChange={(e) => handleQuantityUnit(e.target.value)}
                            formControlProps={{
                                sx: {
                                    width: '100%',
                                    marginTop: '16px !important'
                                }
                            }}
                            inputBaseProps={{
                                inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                            }}
                        />
                    </Grid>

                    <Grid
                        item
                        xl={3}
                        lg={3}
                        sm={3}
                        xs={12}
                    >
                        <Selection
                            id='0'
                            label={'Sign'}
                            value={props.sign}
                            fullWidth={true}
                            hidden={props.TabType === 'Inc Agent' || props.TabType === 'Cost Agent' ? false : true}
                            disabled={props.isViewOnly || props.isReadOnly}
                            placeholder={'Select Sign'}
                            onChange={(e) => props.setSign(e.target.value)}
                        >
                            {
                                signData.map((data, index) => (
                                    <MenuItem sx={{ fontSize: '12px' }} key={index} value={data.code}>{data.name}</MenuItem>
                                ))
                            }
                        </Selection>

                        <Input
                            label={'Per Unit Cost'}
                            textAlign='right'
                            fullWidth
                            value={props.PerUnitCost}
                            disabled={props.isViewOnly || props.isReadOnly}
                            onChange={(e) => handlePerUnitCost(e.target.value)}
                            formControlProps={{
                                sx: {
                                    width: '100%',
                                    marginTop: props.TabType === 'Inc Agent' || props.TabType === 'Cost Agent' ? '16px' : '48px'
                                }
                            }}
                            inputBaseProps={{
                                inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                            }}
                        />
                    </Grid>

                    <Grid
                        item
                        xl={3}
                        lg={3}
                        sm={3}
                        xs={12}
                    >
                        <Selection
                            id='0'
                            label={'Cost Trucking'}
                            fullWidth={true}
                            placeholder={'Select Cost Trucking'}
                            value={props.CostTrucking}
                            onChange={(e) => props.setCostTrucking(e.target.value)}
                            hidden={props.TabType === 'Inc Agent' || props.TabType === 'Cost Agent' ? true : false}
                            disabled={props.isViewOnly || props.isReadOnly}
                        >
                            {
                                CostToCostData.map((data, index) => (
                                    <MenuItem sx={{ fontSize: '12px' }} key={index} value={data.code}>{data.name}</MenuItem>
                                ))
                            }
                        </Selection>

                        <Input
                            label={'Amount'}
                            textAlign='right'
                            fullWidth
                            value={props.Amount}
                            disabled={props.isViewOnly || props.isReadOnly}
                            onChange={(e) => props.setAmount(e.target.value)}
                            formControlProps={{
                                sx: {
                                    width: '100%',
                                    marginTop: props.TabType === 'Inc Agent' || props.TabType === 'Cost Agent' ? '48px' : '16px'
                                }
                            }}
                            inputBaseProps={{
                                inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                            }}
                        />
                    </Grid>

                    <Grid
                        item
                        xl={3}
                        lg={3}
                        sm={3}
                        xs={12}
                    >
                        <Selection
                            id='0'
                            label={'Cost To Cost'}
                            fullWidth={true}
                            placeholder={'Select Cost To Cost'}
                            value={props.CostToCost}
                            onChange={(e) => props.setCostToCost(e.target.value)}
                            disabled={props.isViewOnly || props.isAdditional || props.isReadOnly}
                        >
                            {
                                CostToCostData.map((data, index) => (
                                    <MenuItem sx={{ fontSize: '12px' }} key={index} value={data.code}>{data.name}</MenuItem>
                                ))
                            }
                        </Selection>
                    </Grid>
                </Grid>
            </div>

            <Grid
                container
                spacing={'32px'}
            >
                <Grid
                    item
                    xl={6}
                    lg={6}
                    sm={6}
                    xs={12}
                ></Grid>

                <Grid
                    item
                    xl={3}
                    lg={3}
                    sm={3}
                    xs={12}
                >
                    <Input
                        label={'Original Rate'}
                        textAlign='right'
                        value={props.OriginalRate}
                        disabled={props.isViewOnly || props.isReadOnly}
                        onChange={(e) => handleOriginalRate(e.target.value)}
                        formControlProps={{
                            sx: {
                                width: '100%',
                                marginTop: '16px'
                            }
                        }}
                        inputBaseProps={{
                            inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                        }}
                    />
                </Grid>

                <Grid
                    item
                    xl={3}
                    lg={3}
                    sm={3}
                    xs={12}
                >
                    <Input
                        label={'Original USD'}
                        textAlign='right'
                        value={props.OriginalUSD}
                        disabled={props.isViewOnly || props.isReadOnly}
                        onChange={(e) => handleOriginalUSD(e.target.value)}
                        formControlProps={{
                            sx: {
                                width: '100%',
                                marginTop: '16px'
                            }
                        }}
                        inputBaseProps={{
                            inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    )

    const handleCancel = () => {
        props.handleModalDetail()
        props.setIsContainer(false)
        props.setContainerSize('All');
    }

    const buttonComponent = (
        <div style={{ padding: '6px 24px 12px' }}>
            {CustomizeButtonComponent.SaveCancelModalButton(handleCheckNominal, false, ((props.isViewOnly || props.isReadOnly === true) || props.refId !== 0 ? true : false))}
        </div>
    )

    return (
        <>
            <PopUp
                id='modal-id'
                icon={
                    <Icon
                        iconName={'approve-doc'}
                        svgIconProps={{
                            htmlColor: '#0087C2',
                            sx: {
                                height: '24px',
                                width: '24px'
                            }
                        }}
                    />
                }
                title={props.TabType}
                isOpen={props.showDetail}
                onClose={handleCancel}
                draggable={true}
                shrinkable={true}
                disableScrollLock={true}
                maxWidth={'lg'}
                fullWidth={true}
                topButton={false}
                children={mainContainer}
                actions={buttonComponent}
            />

            {
                props.showModalAccount && (
                    <ModalAccount
                        show={props.showModalAccount}
                        containerSizeData={props.containerSizeData}
                        handleModalAccount={props.handleModalAccount}
                        setSelectedData={(e) => props.setSelectedAccount(e)}
                        SelectedData={props.SelectedAccount}
                        setDesc={props.setDesc}
                        setAccountId={props.setAccountId}
                        setAccountCode={props.setAccountCode}
                        setAccountName={props.setAccountName}
                        setIsContainer={props.setIsContainer}
                        isAdd={props.isAdd}

                        volume20={props.volume20}
                        setVolume20={props.setVolume20}
                        isVolume20={props.isVolume20}
                        setIsVolume20={props.setIsVolume20}

                        volume40={props.volume40}
                        setVolume40={props.setVolume40}
                        isVolume40={props.isVolume40}
                        setIsVolume40={props.setIsVolume40}

                        volume45={props.volume45}
                        setVolume45={props.setVolume45}
                        isVolume45={props.isVolume45}
                        setIsVolume45={props.setIsVolume45}

                        volumeCBM={props.volumeCBM}
                        setVolumeCBM={props.setVolumeCBM}
                        isVolumeCBM={props.isVolumeCBM}
                        setIsVolumeCBM={props.setIsVolumeCBM}

                        setCOACode={props.setCOACode}
                        setCOAName={props.setCOAName}

                        containerSize={props.containerSize}
                        setContainerSize={props.setContainerSize}
                        containerTypeId={props.containerTypeId}
                        setContainerTypeId={props.setContainerTypeId}
                        containerTypeCode={props.containerTypeCode}
                        setContainerTypeCode={props.setContainerTypeCode}
                        containerTypeName={props.containerTypeName}
                        setContainerTypeName={props.setContainerTypeName}
                        containerFormat={props.containerFormat}
                        setContainerFormat={props.setContainerFormat}
                        setQtyUnit={props.setQtyUnit}
                        data={props.dataAccount}
                        isLoading={props.isLoadingAccount}
                        dataMap={props.dataMapAccount}
                        columnData={props.columnDataAccount}
                        totalRows={props.totalRowsAccount}
                        getData={props.getDataAccount}
                        handleQuantityUnit={handleQuantityUnit}
                        setIsOthers={props.setIsOthers}
                    />
                )
            }

            {
                isModalConfirmation && (
                    <ModalConfirmationNominal
                        isModal={isModalConfirmation}
                        handleClick={handleClickConfirmation}

                        nominal={props.Amount}
                        currency={currency}
                        ConfirmationData={handleConfirmation}
                    />
                )
            }
        </>
    );
}

export default React.memo(ModalDetail)